import leaveDoor from '../assets/images/leaveDoor.png';
import meetOutside from '../assets/images/meetOutside.png';
import meetAtDoor from '../assets/images/meetAtDoor.png';
import giftCardImageOne from '../assets/images/giftCardImageOne.png';
import giftCardImageThree from '../assets/images/giftCardImageThree.png';

export const routeNames = {
  home: '/',
  notfound: '/notfound',
  profile: '/profile',
  checkout: '/checkout',
  restaurants: '/restaurants',
  termsAndConditions: '/terms-of-use',
  restaurant: '/restaurant/:id',
  trackOrder: '/track-orders/:id',
  resetPassword: '/resetpassword',
  orderSuccess: '/order-success/:id/:restaurantId',
  accountDetails: '/account-details/:tab',
  accountDetailsAccount: '/account-details/account',
  accountDetailsAddresses: '/account-details/addresses',
  accountDetailsOrderHistory: '/account-details/order-history',
  accountDetailsWebsiteTheme: '/account-details/website-theme',
  giftCards: '/gift-cards',
  purchaseGift: '/purchase-gift',
  redeemGift: '/redeem-gift',
  giftOrderConfirmation: '/gift-order-confirmation',

  /* Restaurant menu and order router */
  restaurantMenu: '/menu',
  restaurantOrder: '/order',
  contact: '/contact',
  aboutus: '/aboutus',
  oauthCallback: '/auth/callback',

  /* Development / staging only — shows all four visual templates side-by-side */
  templatePreview: '/template-preview',
};

export const filterRestaurantTypePage = {
  list: 'list',
  map: 'map',
};

export const sortOptions = [
  {
    testId: 'name',
    text: 'A-Z',
    target: 'name',
  },
  {
    testId: 'distance',
    text: 'Nearest',
    target: 'location',
    type: 'takeout',
  },
  {
    testId: 'fee',
    text: 'Fee',
    target: 'fees',
  },
  {
    testId: 'orderType',
    text: 'Soonest',
    target: 'delays',
    type: 'delivery',
  },
];

export const orderStatuses = {
  open: 'open',
  confirmed: 'confirmed',
  driving: 'driving',
  canceled: 'canceled',
  completed: 'completed',
  Completed: 'Completed',
  Progress: 'In Progress',
};

export const TITLE_PAYMENT = 'Payment';

export const DELIVERY_OPTIONS = [
  { value: 'meet_at_door', label: 'Meet at Door', image: meetAtDoor },
  { value: 'leave_at_door', label: 'Leave at Door', image: leaveDoor },
  { value: 'meet_outside', label: 'Meet outside', image: meetOutside },
];

export const TAKEOUT = 'Takeout';
export const DELIVERY = 'Delivery';

export const EMOJI_UNI_CODE = '0x1F389';

export const notificationTypes = {
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
};

export const doAppearIn = [
  routeNames.checkout,
  routeNames.orderSuccess,
  routeNames.restaurants,
  routeNames.accountDetails,
  routeNames.home,
  routeNames.termsAndConditions,
  routeNames.purchaseGift,
  routeNames.redeemGift,
  routeNames.giftOrderConfirmation,
];

export const MIN_SHOW_RATING_REVIEWS = 15;
export const TRACK_ORDER_API_CALL_INTERVAL = 60 * 1000;
// Fallback for the Eatzy backend checkout TTL (60 minutes). The source of
// truth is the `ttl_seconds` field returned on the POST /checkout/start
// response (consumed in Checkout.jsx). This constant is only used when the
// API response omits that field, so older API versions still expire stale
// checkout ids on the same 60-min cadence the backend used historically.
export const CHECKOUT_STALE_AGE_MS = 60 * 60 * 1000;

export const RATING_FORM_ID = 1;

export const giftQuestion = [
  {
    question: 'How do I redeem a gift card?',
    answer:
      'Enter your Gift Certificate code at checkout, in your Account Details page or in the Redeem Gift Card box above. The Gift Certificate value will be added to your Gift Certificate balance and will be available to use at checkout.\n',
  },
  {
    question: 'Do the Gift Cards expire?',
    answer:
      'Gift Certificate codes expire after one year. Once it has been redeemed, the Gift Certificate balance in your account does not expire.\n',
  },
  {
    question: 'Can I change the amount after the gift card is sent?',
    answer:
      'Please contact support@eatzy.com If the gift card has not yet been redeemed, we may be able to assist.\n',
  },
  {
    question: 'Do you offer physical gift certificates?',
    answer: 'No, not at this time\n',
  },
  {
    question: 'I never received a gift card',
    answer: 'Please contact support@eatzy.com\n',
  },
  {
    question: 'How do I resend a gift card?',
    answer:
      'In your Gift Certificates section of the Account Details page, you have the option to resend any gift certificate that has not been redeemed.\n',
  },
];

export const giftCardDetail = [
  {
    To: 'Tony Stark (tonystark@starktowers.com)',
    From: 'Jane Andrews (janeandrews@gmail.com)',
    DeliveryDate: '9/15/2022',
    message: 'Happy Birthday',
    cardCode: 'XXXX-XXXX-XXXX-XXXX',
    image: giftCardImageOne,
  },
  {
    To: 'Tony Stark (tonystark@starktowers.com)',
    From: 'Jane Andrews (janeandrews@gmail.com)',
    DeliveryDate: '9/15/2022',
    message: 'Happy Birthday',
    cardCode: 'XXXX-XXXX-XXXX-XXXX',
    image: giftCardImageThree,
  },
  {
    To: 'Tony Stark (tonystark@starktowers.com)',
    From: 'Jane Andrews (janeandrews@gmail.com)',
    DeliveryDate: '9/15/2022',
    message: 'Happy Birthday',
    cardCode: 'XXXX-XXXX-XXXX-XXXX',
    image: giftCardImageOne,
  },
  {
    To: 'Tony Stark (tonystark@starktowers.com)',
    From: 'Jane Andrews (janeandrews@gmail.com)',
    DeliveryDate: '9/15/2022',
    message: 'Happy Birthday',
    cardCode: 'XXXX-XXXX-XXXX-XXXX',
    image: giftCardImageThree,
  },
];

export const giftActivityType = {
  payment: 'order_menu_checkout',
  redemption: 'redeem_gift_certificate',
};

export const giftActivityTabMap = {
  viewall: {
    id: 'viewall',
    label: 'View All',
    statusList: [],
  },
  payment: {
    id: 'payment',
    label: 'Payment',
    statusList: [giftActivityType.payment],
  },
  redemption: {
    id: 'redemption',
    label: 'Redemption',
    statusList: [giftActivityType.redemption],
  },
};
